/**
 * Les applications susceptibles d'utiliser le composant de téléversement, à enrichir au fur et à mesure
 * Représente le répertoire de stockage dans attachments/<application>/YYYY-MM-DD/fichier
 */
export enum ApplicationEnum {
  default = 'core',
  demat = 'demat',
  archivage = 'archivage',
  ater = 'ater',
  suaps = 'suaps',
}
